<template>
    <v-ons-page id="gallery">
        <TopBar back="true"></TopBar>
        <v-ons-carousel fullscreen swipeable auto-scroll overscrollable
                        :index.sync="carouselIndex">

            <v-ons-carousel-item v-for="(item, key) in fullItem" :key="key">
                <div class="fullImage ">
                    <img class="art" :src="item.img"/>

                </div>
                <div class="right mt-5" @click="push(item.img)"><img style="height: 5vw;" :src="resizeImage"/>
                </div>
                <div class="textContent ">
                    <span class="font36pt">{{item.line1}}</span>
                    <br>
                    <span class="font29pt">{{item.line2}}</span>
                    <br>
                    <span class="font29pt">{{item.line3}}</span>
                    <br>
                    <span class="font29pt">{{item.line4}}</span>
                </div>
            </v-ons-carousel-item>
        </v-ons-carousel>

        <v-ons-bottom-toolbar class="white">
            <div class="container">
                <div class="left" @click="back()"><img style="height: 5vw;" :src="backImage"/></div>
                <div class="center"></div>
                <div class="right" @click="next()"><img style="height: 5vw;" :src="nextImage"/></div>
            </div>
        </v-ons-bottom-toolbar>

    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import ImagesPage from './ImagePage'

    export default {
        name: 'gallery',
        data: function () {
            return {
                carouselIndex: 0,
                backImage: require('../assets/img/UI/carrousel-left.png'),
                nextImage: require('../assets/img/UI/carrousel-right.png'),
                resizeImage: require('../assets/img/UI/Recurso 31.png'),

            }
        },
        props: [
            'item'
        ],
        components: {
            TopBar
        },
        computed: {
            fullItem() {
                this.item.gallery.forEach(function (elementMenuItem) {

                    elementMenuItem.img = elementMenuItem.img;

                });
                return this.item.gallery;
            }
        },
        methods: {
            push(item) {
                this.$emit('push', {
                    extends: ImagesPage,
                    onsNavigatorProps: {
                        image: item,

                    }
                });
            },
            next() {
                if (this.fullItem.length - 1 === this.carouselIndex) {
                    this.carouselIndex = 0;
                } else {
                    this.carouselIndex++;
                }
            },
            back() {
                if (0 === this.carouselIndex) {
                    this.carouselIndex = this.fullItem.length;
                } else {
                    this.carouselIndex--;
                }

            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hidde {
        display: none;
    }

    #gallery .page__content {
        top: 0% !important;
    }

    #gallery .page--material__content {
        top: 0% !important;
    }

    .fullImage {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .art {
        max-width: 100%;
        height: 77vw;
    }

    .textContent {
        padding: 0% 10%;
        overflow: auto;
    }

    @media only screen and (max-device-height: 800px) {
        .textContent {
            height: 28%;
        }
    }

    @media only screen and (max-device-height: 600px) {
        .textContent {
            height: 32%;
        }
    }
    @media only screen and (max-device-height: 550px) {
        .textContent {
            height: 26%;
        }
    }
    @media only screen and (max-device-height: 500px) {
        .textContent {
            height: 21%;
        }
    }
    @media only screen and (max-device-height: 450px) {
        .textContent {
            height: 11%;
        }
    }

    .mt-10 {
        margin-top: 10px;
    }

    .mt-5 {
        margin-top: 5px;
    }

    .white {
        background: white;
        height: 9.05%;
    }

    .container {
        display: flex;
        width: 100%;
        height: 100%;

    }

    .left {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 10%;
    }

    .right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 10%;
    }

    .center {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/GalleryPage.vue